/**
 * True on macOS/iOS. Decides which modifier is the primary chord key: Command
 * there, Control everywhere else. Evaluated once at module load — a session
 * cannot change platform.
 */
export const IS_MAC =
  typeof navigator !== "undefined" &&
  /Macintosh|Mac OS X|iPhone|iPad|iPod/.test(navigator.userAgent);
